import type { ScreenshotConfig } from '../types'

// Wardrobes use the static cameraPosition from viewer.ts for screenshots.
// (Width-based scaling is stand/tv-stand only.)
export const screenshot: ScreenshotConfig = {}
